export default __webpack_public_path__ + "static/media/pink-wave.262230a7.svg";